<script setup lang="ts">
interface OnboardingBaseProps {
	containerClasses?: string;
	contentAreaClasses?: string;
	buttonAreaClasses?: string;
}

const props = withDefaults(defineProps<OnboardingBaseProps>(), {
	containerClasses: 'flex flex-col bg-white',
	contentAreaClasses: 'flex w-full flex-1 flex-col',
	buttonAreaClasses: 'flex w-full items-end justify-center'
});
</script>

<template>
	<div :class="props.containerClasses">
		<div :class="props.contentAreaClasses">
			<!-- Image Slot -->
			<slot name="image" />

			<!-- Content Slot -->
			<slot name="content" />
		</div>

		<!-- Button Slot -->
		<div :class="props.buttonAreaClasses">
			<slot name="button" />
		</div>
	</div>
</template>
